import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';

const HoverLinkBtnBlock = styled.span`
width: 100%;
position: relative;
display: inline;
&:after {
    content: '';
    display: block;
    position: absolute;
    width: ${props => props.isUnder ? '100%' : '0%'};
    left: 0;
    bottom: ${props => props.bottom || '11px'};
    height: ${props => props.height || '8px'};
    //background-color: #79b88a;
    //background-color: ${isMobileOnly?"#111111":"#79b88a"};
    background-color: #111111;
    z-index: -1;
    -webkit-transition: width .2s ease-in;
    -o-transition: width .2s ease-in;
    transition: width .2s ease-in;
}

&:hover::after {
    width: 100%;
}
`;

const HoverLinkBtnDotBlock = styled.span`
    position: absolute;

    ::after,
    ::before {
        content: '';
        display: block;
        position: absolute;
        top: -8px;
        width: 4px;
        height: 4px;
        background-color: #111;
        border-radius: 50%
    }
    ::before {
        right: 22px;
    }

    ::after{
        right: 5px;
    }
`;

const HoverLinkBtn = ({ text, onClick, bottom, height, isDot, link, isUnderLine, icon= null, iconWidth = null, iconHeight = null  , iconValign = "middle", external=false}) => {
    return (<>{external ?
    <a href={link} target="_blank" rel="noopener">
      <HoverLinkBtnBlock
        bottom={bottom} height={height} onClick={onClick} isUnder={isUnderLine}>
        {text} {!!icon ? <img style={{
        verticalAlign: iconValign,
        width: !!iconWidth ? iconWidth : "100%",
        height: !!iconHeight ? iconHeight : "100%"
      }} src={icon}/> : ""}
        {isDot ? <HoverLinkBtnDotBlock/> : ''}
      </HoverLinkBtnBlock>
    </a>
    :
    <Link to={link}>
      <HoverLinkBtnBlock
        bottom={bottom} height={height} onClick={onClick} isUnder={isUnderLine}>
        {text} {!!icon ? <img style={{
        verticalAlign: iconValign,
        width: !!iconWidth ? iconWidth : "100%",
        height: !!iconHeight ? iconHeight : "100%"
      }} src={icon}/> : ""}
        {isDot ? <HoverLinkBtnDotBlock/> : ''}
      </HoverLinkBtnBlock>
    </Link>
}</>);
};

export default HoverLinkBtn;
